import React from 'react';

const UysotLogoIcon = () => (
  <svg width="101" height="28" viewBox="0 0 101 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 25.4999C3 24.1193 4.15126 23 5.57143 23H24.4286C25.8488 23 27 24.1193 27 25.4999C27 26.8807 25.8488 28 24.4286 28H5.57143C4.15126 28 3 26.8807 3 25.4999Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6733 0.753153C14.6822 -0.251051 16.3178 -0.251051 17.3267 0.753153L30.2435 13.6103C31.2522 14.6145 31.2522 16.2426 30.2435 17.2468C29.2346 18.2511 27.5989 18.2511 26.59 17.2468L15.5 6.20797L4.41003 17.2468C3.40117 18.2511 1.7655 18.2511 0.756642 17.2468C-0.252214 16.2426 -0.252214 14.6145 0.756642 13.6103L13.6733 0.753153Z"
      fill="white"
    />
    <path
      d="M19 17C19 19.2091 17.2091 21 15 21C12.7909 21 11 19.2091 11 17C11 14.7909 12.7909 13 15 13C17.2091 13 19 14.7909 19 17Z"
      fill="#FFAB55"
    />
    <path
      d="M45.6568 7.21768V15.0804C45.6568 16.6912 46.6157 17.7448 48.3223 17.7448C50.0202 17.7448 50.9791 16.6912 50.9791 15.0804V7.21768H53.6358V15.3416C53.6358 18.1105 51.5685 20 48.3223 20C45.0673 20 43 18.1105 43 15.3416V7.21768H45.6568Z"
      fill="white"
    />
    <path
      d="M62.0196 19.7823H59.3628V15.0891L54.9466 7.21768H57.8409L60.6824 12.5814H60.744L63.5943 7.21768H66.4446L62.0196 15.0891V19.7823Z"
      fill="white"
    />
    <path
      d="M66.9108 16.2036H69.4708C69.594 17.2398 70.6848 17.919 72.0924 17.919C73.5087 17.919 74.4764 17.2485 74.4764 16.3255C74.4764 15.507 73.8694 15.0543 72.3387 14.7147L70.6848 14.3577C68.3448 13.8614 67.1923 12.6859 67.1923 10.8486C67.1923 8.53249 69.2157 7 72.0484 7C75.0042 7 76.8605 8.50636 76.9044 10.779H74.4148C74.3269 9.71668 73.3856 9.07234 72.0572 9.07234C70.7464 9.07234 69.8667 9.69056 69.8667 10.6222C69.8667 11.3972 70.4825 11.8326 71.9428 12.1634L73.4823 12.4856C76.0247 13.0255 77.1332 14.1052 77.1332 16.0208C77.1332 18.4588 75.1362 20 71.9868 20C68.9342 20 66.99 18.5633 66.9108 16.2036Z"
      fill="white"
    />
    <path
      d="M84.4964 7C88.2528 7 90.6193 9.499 90.6193 13.5044C90.6193 17.501 88.2528 20 84.4964 20C80.7312 20 78.3736 17.501 78.3736 13.5044C78.3736 9.499 80.7312 7 84.4964 7ZM84.4964 9.19424C82.4203 9.19424 81.0831 10.866 81.0831 13.5044C81.0831 16.134 82.4115 17.7971 84.4964 17.7971C86.5726 17.7971 87.901 16.134 87.901 13.5044C87.901 10.866 86.5726 9.19424 84.4964 9.19424Z"
      fill="white"
    />
    <path d="M97.3228 19.7823H94.666V9.3858H90.9976V7.21768H101V9.3858H97.3228V19.7823Z" fill="white" />
  </svg>
);

export default UysotLogoIcon;
